import { Controller } from "@hotwired/stimulus";

// Sets the width of a progress/meter bar from a `data-usage-bar-pct-value`.
//
// The percentage is computed server-side, but the app CSP (`style_src` has no
// `unsafe_inline`) blocks static inline `style="width: N%"` attributes on the
// rendered HTML (nonces/hashes don't apply to style attributes per the CSP
// spec). Programmatic `el.style.width =` assignments are NOT governed by
// `style-src`, so a nonce'd Stimulus controller is the CSP-safe way to drive
// dynamic bar widths.
export default class extends Controller {
  static values = { pct: Number };

  connect() {
    this.#apply();
  }

  // Re-apply when the value changes (e.g. after a Turbo morph).
  pctValueChanged() {
    this.#apply();
  }

  #apply() {
    const pct = Number(this.pctValue || 0);
    // Clamp to [1, 100] so an unused meter still shows a faint sliver —
    // matches the previous inline-style behaviour (the meter reads as
    // "alive" rather than broken when usage is 0).
    const clamped = Math.min(Math.max(pct, 1), 100);
    this.element.style.width = `${clamped}%`;
  }
}
